import ReactApexChart from "react-apexcharts";
export default function RingChartItem({value, unit, targetValue}){
  // const value = data.data.value;
  const colors = ["#8CAE68", "#FF6347","#B3679B","#FFBA49","#175676","#90A9B7","#3F292B"]
  const random = Math.floor(Math.random() * colors.length);
  const percentage = value/targetValue;
  const label = `${value}${unit}`
  const options ={
    chart: {
      type: 'radialBar',
      foreColor: '#FF6347'
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 360,
        track: {
          background: '#C4C4C4',
          strokeWidth: '100%',
          margin: 0,
          dropShadow: {
            enabled: false,
            top: 14,
            left: 0,
            blur: 10,
            opacity: 0.25,
            color: `${colors[random]}`
          }
        },
    
        dataLabels: {
          show: true,
          name: {
            offsetY: 100,
            show: false,
            color: '#000',
            fontSize: '80%'
          },
          value: {
            formatter: function(val) {
              const val1 = parseInt(val);
              return `${val1}%`
            },
            color: '#111',
            fontSize: '150%',
            fontWeight: "bold",
            offsetY:10,
            show: true,
          },
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        colorStops: [
          {
            offset: 0,
            color: `${colors[random]}`,
            opacity: 0.3
          },
          {
            offset: 50,
            color: `${colors[random]}`,
            opacity: 0.55
          },
          {
            offset: 100,
            color: `${colors[random]}`,
            opacity: 1
          }]
      }
    },
    stroke: {
      lineCap: 'round'
    },
    labels: [label],
  }
  const series = [percentage*100]
  return(
    <div id="chart">
      <ReactApexChart options={options} series={series} type="radialBar" />
    </div>
  );
}